<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    trap-focus
    aria-role="dialog"
    aria-modal class="has-overflow">
      <div class="modal-card">
        <ValidationObserver ref="observer">
          <header class="modal-card-head">
              <p class="modal-card-title">{{titleForm}}</p>
          </header>
          <section class="modal-card-body" style="min-height: 200px;">
            <b-field grouped>
              <b-field expanded>
                <ValidationProvider
                  name="Fecha Inicio"
                  :rules="'required'"
                  v-slot="{ errors }">
                  <b-field label="Fecha Inicio"
                  :type="{ 'is-danger': errors[0] }"
                  :message="errors">
                    <b-datepicker
                          placeholder="Selecciona una fecha"
                          v-model="startDate"
                          :first-day-of-week="1"
                          :month-names="$moment.months()"
                          :day-names="$moment.weekdaysShort()"
                          :unselectable-days-of-week="[0]"
                          :mobile-native="false"
                          :max-date="endDate"
                          expanded>
                          <button class="button is-danger"
                              @click="startDate = null">
                              <b-icon icon="close"></b-icon>
                              <span>Limpiar</span>
                          </button>
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field expanded>
                <ValidationProvider
                  name="Fecha Termino"
                  :rules="''"
                  v-slot="{ errors }">
                  <b-field label="Fecha Termino"
                  :type="{ 'is-danger': errors[0] }"
                  :message="errors">
                    <b-datepicker
                          placeholder="Selecciona una fecha"
                          v-model="endDate"
                          :first-day-of-week="1"
                          :month-names="$moment.months()"
                          :day-names="$moment.weekdaysShort()"
                          :unselectable-days-of-week="[0]"
                          :mobile-native="false"
                          :min-date="startDate"
                          expanded>
                          <button class="button is-danger"
                              @click="endDate = null">
                              <b-icon icon="close"></b-icon>
                              <span>Limpiar</span>
                          </button>
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </b-field>
            </b-field>
            <b-field label="Nombre Automático">
              <b-switch
                v-model="calcName"
                >
                {{ calcName ? 'Si' : 'No'}}
              </b-switch>
            </b-field>
            <ValidationProvider
              name="Nombre"
              :rules="'required'"
              v-slot="{ errors }">
                <b-field
                  label="Nombre"
                  :type="{ 'is-danger': errors[0] }"
                  :message="errors">
                    <b-input  placeholder="Nombre descriptivo del día" v-model="service.name"></b-input>
                </b-field>
            </ValidationProvider>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="isActiveModal = false">Cancelar</b-button>
            <b-button type="is-primary" @click="save" :loading="isLoading">Guardar</b-button>
          </footer>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
import ServiceService from '@/services/ServiceService'
import CredentialsService from '@/services/CredentialsService'

export default {
  components: {
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    },
    serviceId: {
      required: false
    }
  },
  created () {
    if (this.serviceId) {
      this.loadService()
    }
  },
  data () {
    return {
      isActiveModal: this.active,
      isLoading: false,
      startDate: null,
      endDate: null,
      calcName: false,
      service: {
        name: null,
        description: null,
        service_type_id: 1,
        tenant_id: 1,
        created_by: 1,
        provider_id: 1,
        start_date: null,
        end_date: null,
        cost: 0,
        currency_id: 1,
        info: null,
        service_status_id: 1
      }
    }
  },
  methods: {
    async loadService () {
      try {
        let response = await ServiceService.getService(this.serviceId)
        let service = response.data.data
        this.calcName = false
        if (service) {
          this.startDate = service.start_date ? this.$moment(service.start_date, 'YYYY-MM-DD').toDate() : null
          this.endDate = service.end_date ? this.$moment(service.end_date, 'YYYY-MM-DD').toDate() : null
          this.service = service
        }
      } catch (error) {
        console.log(error)
      }
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true

        try {
          let response = null
          let text = ''
          this.service.created_by = CredentialsService.getUser().id

          if (this.serviceId) {
            response = await ServiceService.updateService(this.serviceId, this.service)
            text = 'Servicio editado exitosamente'
          } else {
            response = await ServiceService.createService(this.service)
            text = 'Servicio creado exitosamente'
          }

          if (response.status >= 200 && response.status < 300) {
            this.success(text)
            this.$emit('saved')
          } else {
            this.error()
          }
        } catch (error) {
          console.log(error)
          this.error()
        }
        this.clearData()
        this.isLoading = false
        this.isActiveModal = false
      }
    },
    clearData () {
      this.startDate = null
      this.endDate = null
      this.service = {
        name: null,
        description: null,
        service_type_id: 1,
        tenant_id: 1,
        created_by: 1,
        provider_id: 1,
        start_date: null,
        end_date: null,
        cost: 0,
        currency_id: 1,
        info: null,
        service_status_id: 1
      }
      this.$emit('update:serviceId', null)
    },
    success (text) {
      this.$buefy.toast.open({
        message: text,
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo realizar los cambios',
        type: 'is-danger'
      })
    },
    formatName () {
      let date = this.startDate
      if (date && this.calcName) {
        let formatedDate = this.$moment(date).format('MMMM YYYY')
        this.service.name = `${formatedDate.charAt(0).toUpperCase()}${formatedDate.slice(1)}`
      }
    }
  },
  watch: {
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
        if (!this.isActiveModal) {
          this.clearData()
        }
      }
    },
    startDate (value) {
      this.formatName()
      this.service.start_date = value ? this.$moment(value).format('YYYY-MM-DD') : null
    },
    endDate (value) {
      this.service.end_date = value ? this.$moment(value).format('YYYY-MM-DD') : null
    },
    serviceId (value) {
      if (value) {
        this.loadService()
      }
    },
    calcName (value) {
      if (value) {
        this.formatName()
      }
    }
  },
  computed: {
    typeId () {
      return this.type ? this.type.id : null
    },
    titleForm () {
      return this.offDay ? 'Editar Día' : 'Crear nuevo servicio de herraje'
    }
  }
}
</script>
